import React from 'react';

export default function SoundIcon({ color }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7515 3.43968V5.00015V19.0022V20.5627L12.5329 19.5879L7.73765 15.7516H4.5H3.75V15.0016V9.00074V8.25074H4.5H7.73765L12.5329 4.4145L13.7515 3.43968ZM12.2515 6.56062L8.46925 9.58639L8.26382 9.75074H8.00073H5.25V14.2516H8.00073H8.26382L8.46925 14.416L12.2515 17.4417V6.56062ZM18.002 3.93949L18.5323 4.46982C22.8346 8.77209 22.8102 15.2546 18.5323 19.5325L18.002 20.0629L16.9413 19.0022L17.4716 18.4719C21.166 14.7776 21.1859 9.24475 17.4716 5.53048L16.9413 5.00015L18.002 3.93949ZM16.5708 8.51364L16.0843 7.94284L14.9427 8.91585L15.4292 9.48665C15.9546 10.1031 16.25 11.0256 16.25 12.0001C16.25 12.9747 15.9546 13.8972 15.4292 14.5136L14.9427 15.0844L16.0843 16.0575L16.5708 15.4866C17.3787 14.5387 17.75 13.2435 17.75 12.0001C17.75 10.7568 17.3787 9.46159 16.5708 8.51364Z"
        fill={color}
      />
    </svg>
  );
}
